module.exports = __webpack_public_path__ + "static/media/cupertron.50a0e83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/antracnosis_aguacate/preventiva/cupertron.png
// module id = 1086
// module chunks = 3